export default ({
  pageState: { editorAdders }
}) => {
  return {
    editorAdders: editorAdders.map(() => false)
  }; 
};
